module.exports = __webpack_public_path__ + "media/images/Tiled-Wall-2-551074bee3da447158e3dfc8ad57c9c1.png";